export default __webpack_public_path__ + "static/media/family_responsibility_office_dispute.142a2512.svg";